
import {
    Box, Button, CardContent, Grid, Typography, TextField, MenuItem,
    Select,
    FormControl,
    InputLabel,
    ListSubheader,
} from "@mui/material"
import { useEffect, useMemo, useState } from "react";
import { getDateTime, getDayOption, getMonthOption, getPayPeriods } from '../../../../utils/genericMethod';
import { useTQuery } from '../../../../utils/useTQuery';
import { CustomPagination } from '../../AdminComponents/CustomTable';
import DataTable from 'react-data-table-component';


export const InvoiceAccounting = ({ selectedTab }) => {
    const [showResetButton, setShowResetButton] = useState(false);
    const payPeriods = useMemo(() => getPayPeriods(), []);
    const [period, setPeriod] = useState(null);
    const [customFrom, setCustomFrom] = useState('');
    const [customTo, setCustomTo] = useState('');
    const [InvoicePeriodDate, setInvoicePeriodDate] = useState('');
    const [customError, setCustomError] = useState('')

    const initialPayload = {
        dates: {}, page: 1, rowsPerPage: 10
    }
    //Pagination 
    const [pagination, setPagination] = useState({
        page: 1,  // Zero-based for the first page
        rowsPerPage: 10,
        totalPage: 0,
    });
    const [payload, setPayload] = useState(initialPayload);
    const { data, isLoading, refetch } = useTQuery(
        ["invoice", payload, selectedTab],
        selectedTab ? `/job/invoiceAccounting` : null,
        'post',
        payload,
        selectedTab?.text === 'Invoice'
    );
    const [payrollData, setPayrollData] = useState([]);


    useEffect(() => {
        if (data?.STATUS) {
            setPayrollData(data?.OUTPUT || []);
            setPagination(prev => ({
                ...prev,
                rowsPerPage: data?.meta?.pageSize ?? 10,
                totalPage: data?.meta?.totalItems ?? 0
            }));
        } else {
            setPayrollData([]);
        }
    }, [selectedTab, data]);

    useEffect(() => {
        console.log("payload useeffect", payload)
        refetch();

    }, [pagination?.page, pagination?.rowsPerPage])

    const payrollColumn = [
        // { name: 'Temp', selector: row => row.Temp, sortable: true },
        { name: 'Shift Worked', selector: row => new Date(row.ShiftDate).toDateString() },
        { name: 'Temp', selector: row => row.Temp + "-" + row.Name, sortable: true },
        // { name: 'Name', selector: row => row.Name, sortable: true },
        { name: 'Dept', selector: row => row.Dept },
        { name: 'Reconciled By', selector: row => row.ReconciledBy },
        // { name: 'Shift Time', selector: row => row.ShiftTime },
        // { name: 'Period', selector: row => row.Period },
        { name: 'Qty', selector: row => row.TotalTime },
        { name: 'Rate', selector: row => `$${row.Rate}` },
        { name: 'Amount Due', selector: row => `$${row.Payment}` },
        { name: 'Status', selector: row => row.Status },
        { name: 'Paid Amount', selector: row => `$${row.PayableAmount}` },
        { name: 'Ref. No', selector: row => row?.TransactionId }
    ];

    const handleReset = () => {
        setPeriod(null);
        setCustomFrom('');
        setCustomTo('');
        setInvoicePeriodDate('');
        setPayload(initialPayload);
        refetch();
        setShowResetButton(false);
    }
    const handleFilterClick = () => {
        const filter = getActiveFilter();
        if (filter.type === 'error') {
            setCustomError(filter.message);
            return;
        }
        const dates = getFilterDates();
        if (dates) {
            setShowResetButton(true);
        }
        const newPayload = {
            ...payload,
            dates,
        };

        setPayload(newPayload); // update state
        refetch();

    };



    const getActiveFilter = () => {
        if (period) return { type: 'Period', message: 'Periods Filter is selected' };
        if (customFrom || customTo) {
            if (!customFrom || !customTo) {
                return { type: 'error', message: 'Select both Custom Date From and To' };
            }
            return { type: 'Custom Date', message: 'Custom Dates Filter is selected' };
        }
        if (InvoicePeriodDate) return { type: 'Invoice', message: 'Invoice Dates Filter is selected' };
        return { type: null, message: '' };
    };

    const handlePeriodChange = (e) => {
        const value = JSON.parse(e.target.value);
        setPeriod(value);
        setCustomFrom('');
        setCustomTo('');
        setInvoicePeriodDate('');
        setCustomError('');
    };
    const handleCustomDateChange = (type, value) => {
        setPeriod(null);
        setInvoicePeriodDate('');
        setCustomError('');
        if (type === 'from') setCustomFrom(value);
        else setCustomTo(value);
    };

    const validateCustomDates = () => {
        setCustomError(''); // Reset first

        if (!customFrom || !customTo) {
            setCustomError('Select both Custom Date From and To');
            return;
        }

        const from = new Date(customFrom);
        const to = new Date(customTo);
        if (to < from) {
            setCustomError('"Custom To" date must be later than or equal to "Custom From" date');
            return;
        }
    };
    const getFilterDates = () => {
        if (period) {
            return { from: period.from, to: period.to };
        }
        if (customFrom && customTo) {

            const from = new Date(customFrom);
            const to = new Date(customTo);
            if (to < from) {
                setCustomError('"Custom To" date must be later than or equal to "Custom From" date');
                return;
            }
            return {
                from: getDateTime(from),
                to: getDateTime(to, true),
            };
        }
        if (InvoicePeriodDate) {
            return {
                from: getDateTime(new Date(InvoicePeriodDate)),
                to: getDateTime(new Date(InvoicePeriodDate), true),
            };
        }
        return null;
    };
    const handleInvoiceDateChange = (value) => {
        setInvoicePeriodDate(value);
        setCustomFrom('');
        setCustomTo('');
        setPeriod(null);
        setCustomError('');
    };

    const safePayrollData = payrollData.map((item, index) => ({
        ...item,
        uniqueKey: `${item.ID}-${index}-${pagination.page}`
    }));


    const handleSort = (column, sortDirection) => {
        const fieldMapping = {
            'Shift Worked': 'ShiftDate',
            'Temp': 'Temp',
            'Dept': 'Dept',
            'Reconciled By': 'ReconciledBy',
            'Qty': 'TotalTime',
            'Rate': 'Rate',
            'Amount Due': 'Payment',
            'Status': 'Status',
            'Paid Amount': 'PayableAmount',
            'Ref. No': 'TransactionId'
        };

        const fieldName = fieldMapping[column.name] || column.name;

        setPayload(prev => ({
            ...prev,
            FIELD: fieldName,
            DIRECTION: sortDirection.toUpperCase(),
            page: 1
        }));

        setPagination(prev => ({
            ...prev,
            page: 1
        }));
    };

    return (
        <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Invoice <span style={{ color: "#6ebe44" }}>Manager</span>
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                        <InputLabel id="period-label">Period</InputLabel>
                        <Select
                            labelId="period-label"
                            value={period ? JSON.stringify(period) : ''}
                            label="Period"
                            onChange={handlePeriodChange}
                        >
                            <ListSubheader>Pay Period</ListSubheader>
                            {payPeriods.map((period, index) => (
                                <MenuItem key={`pay-${index}`} value={JSON.stringify(period)}>
                                    {period.label}
                                </MenuItem>
                            ))}

                            <ListSubheader>Days</ListSubheader>
                            {['Yesterday', 'Today', 'Tomorrow'].map((day) => {
                                const option = getDayOption(day);
                                return (
                                    <MenuItem key={day} value={JSON.stringify(option)}>
                                        {option.label}
                                    </MenuItem>
                                );
                            })}

                            <ListSubheader>Months</ListSubheader>
                            {['Last Month', 'This Month'].map((month) => {
                                const option = getMonthOption(month);
                                return (
                                    <MenuItem key={month} value={JSON.stringify(option)}>
                                        {option.label}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                {/* Custom Date From */}
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                        <TextField
                            fullWidth
                            label="Custom From"
                            type="date"
                            variant="outlined"
                            size="small"
                            InputProps={{
                                className: "picker_datefield"
                            }}
                            value={customFrom}
                            onChange={(e) => handleCustomDateChange('from', e.target.value)}
                            onBlur={validateCustomDates}
                            InputLabelProps={{ shrink: true }}
                            error={!!customError}
                        />
                    </FormControl>
                </Grid>

                {/* Custom Date To */}
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                        <TextField
                            fullWidth
                            label="Custom To"
                            type="date"
                            variant="outlined"
                            InputProps={{
                                className: "picker_datefield"
                            }}
                            size="small"
                            value={customTo}
                            onChange={(e) => handleCustomDateChange('to', e.target.value)}
                            onBlur={validateCustomDates}
                            InputLabelProps={{ shrink: true }}
                            error={!!customError}
                            helperText={customError}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth>
                        <TextField
                            fullWidth
                            label="Invoice Period"
                            type="date"
                            variant="outlined"
                            InputProps={{
                                className: "picker_datefield"
                            }}
                            size="small"
                            value={InvoicePeriodDate}
                            onChange={(e) => handleInvoiceDateChange(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </FormControl>
                </Grid>
            </Grid>

            {/* <Typography variant="h6" fontWeight="bold" mt={2}>
                Payroll <span style={{ color: "#6ebe44" }}>Options</span>
            </Typography>      
            <Grid container spacing={2}>
                <Grid item lg={6}>
                    <Grid item xs={12} sm={6} md={6} display="flex" alignItems="center">
                        <Checkbox disabled />
                        <Typography>Preview Incomplete Payroll</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={9} display="flex" alignItems="center">
                        <Checkbox disabled />
                        <Typography>Complete Payroll and mark it complete</Typography>
                    </Grid>

                </Grid>
                <Grid item lg={6}>
                    <Grid item xs={12} sm={6} md={6} display="flex" alignItems="center">
                        <Checkbox disabled />
                        <Typography>View complete Payroll</Typography>
                    </Grid>


                    <Grid item xs={12} sm={6} md={9} display="flex" alignItems="center">
                        <Checkbox disabled />
                        <Typography>View complete Payroll Batch</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="Paycheck Date"
                        type="date"
                        variant="outlined"
                        InputProps={{
                            className: "picker_datefield"
                        }}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

            </Grid> */}


            <Box textAlign="right" mt={2}>
                {showResetButton && <Button variant="outlined" onClick={handleReset}>
                    Reset
                </Button>}
                <Button variant="contained" sx={{ background: "grey", color: "#fff", textTransform: "none", ml: 1 }} onClick={handleFilterClick}>
                    Run Invoice
                </Button>
            </Box>
            {/* Table */}
            <Box mt={2} sx={{ height: '100%', width: '100%' }}>

                <DataTable
                    className="table-items"
                    columns={payrollColumn}
                    data={safePayrollData}
                    keyField="uniqueKey"
                    sortServer
                    onSort={handleSort}
                    progressPending={isLoading}
                    progressComponent={<div>Loading Invoices...</div>}
                />
                <CustomPagination
                    count={pagination.totalPage}
                    rowsPerPage={pagination.rowsPerPage}
                    page={pagination.page - 1}
                    setPage={(newPage) => {
                        setPagination(prev => ({ ...prev, page: newPage + 1 }));
                    }}
                    onChangePage={(newPage) => {
                        setPagination(prev => ({ ...prev, page: newPage + 1 }));
                        setPayload(prev => ({ ...prev, page: newPage + 1 }))
                    }}
                    onChangeRowsPerPage={(rowsPerPage) => {
                        setPagination(prev => ({ ...prev, rowsPerPage, page: 1 }));
                        setPayload(prev => ({ ...prev, rowsPerPage, page: 1 }))
                    }}
                />
            </Box>


        </CardContent>
    );
};






